import React, { useState } from 'react';
import AddWebsiteModal from '../component/formModal/AddWebsiteModal';
import WebsiteTable from '../component/table/WebsiteTable';

const WebsiteDashboard = ({user}) => {
    const [showWebsiteAddModal, setShowWebsiteAddModal] = useState(false);
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>Websites</h3>
          {user && (
            <button
              className="btn btn-primary"
              onClick={() => setShowWebsiteAddModal(true)}
              disabled={user.role === 'EXECUTIVE'}
            >
              <i className="fa fa-plus me-2" />
              Add New website
            </button>
          )}
        </div>
        {user && <WebsiteTable loginUser={user} />}
        {showWebsiteAddModal && <AddWebsiteModal onClose={() => setShowWebsiteAddModal(false)} />}
      </div>
    );
};

export default WebsiteDashboard;